import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/auth/AuthContext';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

export function WelcomePage() {
  const { user, profile, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (authLoading || hasNavigated.current) return;

    const handleNavigation = async () => {
      try {
        if (!user) {
          hasNavigated.current = true;
          navigate('/login', { replace: true });
          return;
        }

        if (profile) {
          hasNavigated.current = true;
          if (!profile.onboarding_progress?.isComplete && window.location.pathname !== '/onboarding') {
            navigate('/onboarding', { replace: true });
          } else if (profile.onboarding_progress?.isComplete && window.location.pathname !== '/dashboard') {
            navigate('/dashboard', { replace: true });
          }
        }
      } finally {
        setLoading(false);
      }
    };

    handleNavigation();
  }, [user, profile, authLoading, navigate]);

  if (loading || authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  return null;
} 